import { combineReducers } from "redux";

import projectReducer from "./project";
import categoryReducer from "./category";
import aboutReducer from "./about";
import servicesReducer from "./services";
import testimonialsReducer from "./testimonials";

export default combineReducers({
  categoryState: categoryReducer,
  projectState: projectReducer,
  aboutState: aboutReducer,
  servicesState: servicesReducer,
  testimonialsState: testimonialsReducer,
});
